import React from 'react';
import Loading from 'react-loader-spinner';
import PropTypes from 'prop-types';

const Loader = (props) => {
  const { type } = props;
  return (
    <div className="extender editor">
      <div className="padder">
        <Loading type={type} color="#e30613" height={100} width={100} />
      </div>
    </div>
  );
};

Loader.propTypes = {
  type: PropTypes.string.isRequired,
};
export default Loader;
